const DELIVERY_REPORT_LABELS = new Map(
  [
    "Admissional",
    "Periódico",
    "Perda",
    "Danos (Rasgos/Quebra)",
    "Esquecimento",
  ].map((label) => [label.toLocaleLowerCase("pt-BR"), label])
);

const normalizeDeliveryLabel = (value?: string | null) =>
  DELIVERY_REPORT_LABELS.get(String(value || "").trim().toLocaleLowerCase("pt-BR")) || null;

export const formatDeliveryReportLabel = (
  deliveryType?: string | null,
  deliveryReason?: string | null
) => {
  const normalizedType = String(deliveryType || "").trim();

  if (normalizedType.toLocaleLowerCase("pt-BR") === "troca") {
    return normalizeDeliveryLabel(deliveryReason) || "—";
  }

  return normalizeDeliveryLabel(normalizedType) || "—";
};
